import { Stack, useRouter, useNavigation } from "expo-router";
import { Pressable } from "react-native";
import { Ionicons } from "@expo/vector-icons";
import { useThemeColors } from "@/providers/ThemeProvider";

/**
 * Layout for Familie Notificaties screens
 */
export default function NotificationsLayout() {
  const colors = useThemeColors();
  const router = useRouter();
  const navigation = useNavigation();

  const handleBack = () => {
    if (navigation.canGoBack()) {
      router.back();
    } else {
      router.replace("/(tabs)/admin");
    }
  };

  return (
    <Stack
      screenOptions={{
        headerShown: true,
        headerStyle: { backgroundColor: colors.surface },
        headerTintColor: colors.primary,
        headerTitleStyle: { color: colors.text },
        headerLeft: () => (
          <Pressable onPress={handleBack} className="mr-2">
            <Ionicons name="arrow-back" size={24} color={colors.primary} />
          </Pressable>
        ),
        contentStyle: { backgroundColor: colors.background },
      }}
    >
      <Stack.Screen
        name="index"
        options={{ title: "Familie notificaties" }}
      />
      <Stack.Screen
        name="settings"
        options={{ title: "Notificatie Instellingen" }}
      />
    </Stack>
  );
}

